
import React from 'react';
import { FacilityOrderTemplateItemNewFlowNoteModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateItemNewFlowNoteModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateItemNewFlowNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateItemNewFlowNoteModalStore')
@observer
class FacilityOrderTemplateItemNewFlowNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateItemNewFlowNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateItemNewFlowNoteModal;
